import 'isomorphic-fetch';

import baseFetch from 'common/baseFetch';
import config from 'config';
import reportErrorToNewRelic from 'utils/reportErrorToNewRelic';

export const getSpotMapData = async ({
  north,
  south,
  east,
  west,
  includeInternalCams = false,
}: {
  north: number;
  south: number;
  east: number;
  west: number;
  includeInternalCams?: boolean;
}) => {
  const url = `/kbyg/mapview?south=${south}&west=${west}&north=${north}&east=${east}${includeInternalCams ? '&includeInternalCams=true' : ''}`;
  return baseFetch(url);
};

export const getNearestSpot = async ({
  lat,
  lon,
  includeInternalCams = false,
}: {
  lat: number;
  lon: number;
  includeInternalCams?: boolean;
}) => {
  const url = `/kbyg/mapview/spot?lat=${lat}&lon=${lon}${includeInternalCams ? '&includeInternalCams=true' : ''}`;
  return baseFetch(url);
};

export const fetchLocationMapView = async (geonameId: string) => {
  const url = `${config.servicesURL}/location/view?type=mapView&id=${geonameId}`;

  const response = await fetch(url);

  const body = await response.json();

  if (response.status === 400) {
    throw new Error(`Bad request: ${response.statusText}`);
  }

  if (response.status > 200) {
    reportErrorToNewRelic(new Error(response.statusText), 'fetchLocationMapView', {
      url,
      geonameId,
      responseStatus: response.status,
    });
    throw new Error(`Failed to fetch location map view: ${response.statusText}`);
  }
  return body;
};
